import { useNavigate } from "react-router-dom";

const DIVS = [
  { key: "homecare", name: "ProactiveHomeCare+" },
  { key: "bh", name: "ProactiveBH+" },
  { key: "clinic", name: "ProactiveClinic+" },
  { key: "medtech", name: "ProactiveMEDTECH+" },
  { key: "core", name: "ProactiveCore+" },
];

export default function DivisionsCarousel() {
  const navigate = useNavigate();
  // duplicate the list so the marquee loops seamlessly
  const items = [...DIVS, ...DIVS];

  return (
    <section className="divcar" data-testid="divisions-carousel">
      <div className="container">
        <div className="divcar__head">
          <span className="ip-kicker">The PUMS Ecosystem</span>
          <h2 className="divcar__title">Explore Our Divisions</h2>
          <p className="divcar__sub">Five specialized divisions, one connected platform — tap any to learn more.</p>
        </div>
      </div>
      <div className="divcar__viewport">
        <div className="divcar__track">
          {items.map((d, i) => {
            const clone = i >= DIVS.length;
            return (
              <button
                key={`${d.key}-${i}`}
                className="divcar__item"
                onClick={() => navigate(`/division/${d.key}`)}
                aria-label={d.name}
                aria-hidden={clone ? "true" : undefined}
                tabIndex={clone ? -1 : 0}
                {...(clone ? {} : { "data-testid": `divcar-${d.key}` })}
              >
                <img src={`/assets/logo-eco-${d.key}.png`} alt={clone ? "" : d.name} loading="lazy" />
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
